module.exports = __webpack_public_path__ + "img/textBtm2.ce7d93d2.png";